import React from 'react';
import Container from '@material-ui/core/Container';
import { useStyles } from '../../../utils/useStyles';
import { routeContainer as RouteContainer } from './listItems';

export default function Merchant_container() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.container}>
      <RouteContainer />
    </Container>
  );
}
